<template>
  <div class="container-fluid px-0 position-relative" style="height: 615px" ref="balanceTab">
    <BaseLoader v-if="localLoading" style="z-index: 100"></BaseLoader>
    <div class="d-flex justify-content-between align-items-center pb-15 pt-15 gap-10">
      <div class="d-flex gap-5 align-items-center">
        <div class="d-flex gap-20 align-items-center me-20" v-if="Object.keys(dataForTab).length">
          <span class="fw-semi-bold fsc-14">{{
            dataLang["clients_register_text_62"]
            }}</span>
          <span class="fsc-20" :style="{
            color:
              dataForTab?.companies__balance >= 0
                ? '#23b14d'
                : 'rgb(255, 36, 0)',
          }">{{ dataForTab?.companies__balance.split(".").join(",") }}</span>
        </div>
        <div class="base-button base-button--action py-10 gap-15 position-relative"
          @click="$modal.show('AddBalanceModal')">
          <span class="fsc-14">
            {{ dataLang["clients_register_text_63"] }}</span>
          <!-- <img
            :src="require(`@/assets/icons/lockdark.svg`)"
            width="10"
            height="10"
            style="position: absolute; top: 1px; right: 1px"
          /> -->
        </div>
        <div class="base-button base-button--action py-10 gap-15 position-relative"
          @click="$modal.show('WriteOffClientsModal')">
          <span class="fsc-14">
            {{ dataLang["clients_register_text_64"] }}</span>
          <!-- <img
            :src="require(`@/assets/icons/lockdark.svg`)"
            width="10"
            height="10"
            style="position: absolute; top: 1px; right: 1px"
          /> -->
        </div>
        <div class="base-button base-button--action py-10 gap-15 position-relative"
          @click="setRemoveModal">
          <span class="fsc-14">
            <img :src="require(`@/assets/icons/adddel.svg`)" width="13.5" height="13.5"/>
            Удалить
          </span>
        </div>
        <div class="base-button base-button--action py-10 gap-5 position-relative" @click="loadExel">
          <img :src="require(`@/assets/icons/to-exel.svg`)" width="16" height="16" />
          <span class="fsc-14">
            {{ dataLang["clients_register_text_67"] }}</span>
          <!-- <img
            :src="require(`@/assets/icons/lockdark.svg`)"
            width="10"
            height="10"
            style="position: absolute; top: 1px; right: 1px"
          /> -->
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mb-15">
      <div class="d-flex gap-15 align-items-center">
        <div class="btn btn-sm btn-thrity text-white fsc-14" @click="loadData(1)">
          {{ dataLang["register_btn_filter_on"] }}
        </div>
        <div class="text-decoration-underline fsc-14 text-dark" style="cursor: pointer" @click="resetFilter">
          {{ dataLang["register_btn_filter_off"] }}
        </div>
      </div>
      <BasePagination :page-count="numPages" :pagination-params="paginationBalanceStateParams" :page-range="13"
        :showLimitInput="false" :margin-pages="0" :break-view-class="''" :click-handler="loadData" :prev-text="''"
        :next-text="''" :container-class="'custom-pagination'" :page-class="'custom-pagination__item'"
        :pageLinkClass="'custom-pagination__item-link'">
      </BasePagination>
    </div>

    <ve-table style="width: 100%" :columns="columns" :table-data="dataTable" :border-x="true" :border-y="true"
      :sort-option="sortOption" ref="serviceTable" row-key-field-name="finreestr__id" :checkbox-option="{
        hideSelectAll: false,
        selectedRowChange: selectedRowChange,
        selectedAllChange: selectedAllChange,
      }" :clickHighlight="false" :rowStyleOption="{
        hoverHighlight: true,
      }" :cellSelectionOption="{ enable: false }" />
    <AddBalanceModal :optionalParams="{ id: tabInfo }"></AddBalanceModal>
    <WriteOffClientsModal :optionalParams="{ id: tabInfo }"></WriteOffClientsModal>
    <BackBalanceClientsModal :optionalParams="{ id: tabInfo }"></BackBalanceClientsModal>

    <BaseModal name="pincode" width="420" :clickToClose="false" :shiftY="0.5" :adaptive="true"
      @beforeOpen="({ params }) => (nextModalFromPin = params?.modal)" height="295"
      classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('pincode')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="mb-10 text-center fw-medium">
            {{ dataLang["reg_company_22"] }}
          </p>
          <div class="d-flex flex-column align-items-center">
            <BaseInputNew placeholder="" :width="'159'" class="mb-10" inputClass="text-center" :input-name="'pincode'"
              @input="(data) => (pincode = data.value)" value="" name-sign="">
            </BaseInputNew>
            <div class="d-flex justify-content-end gap-15">
              <div @click="$modal.hide('pincode')"
                class="btn btn-sm btn-opposite px-20 py-10 rounded-10 d-flex text-uppercase align-items-center justify-content-center">
                {{ dataLang["vehile_modal_btn_reset"] }}
              </div>
              <div @click="() => (pincode ? acceptNext() : '')"
                class="btn btn-sm btn-opposite px-20 py-10 rounded-10 d-flex text-uppercase align-items-center justify-content-center">
                {{ dataLang["tracker_text51"] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal name="RemoveModal" width="420" :clickToClose="false" :shiftY="0.5" @before-close="beforeClose"
    :adaptive="true" height="auto" classes="bg-transparent shadow-none">
    <div class="py-20 px-30 rounded-25 bg-white" style="min-height: 180px">
      <div class="d-flex justify-content-end">
        <slot name="modal-header"></slot>
        <button type="button" class="btn-close" @click="$modal.hide('RemoveModal')"></button>
      </div>
      <div
        class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center container-with-input">
        <p class="fw-bold mb-15 text-center">
          Подтверждение удаления
        </p>

        <div class="d-flex justify-content-end gap-15">
          <div class="base-button px-20 rounded-5 text-uppercase" @click="$modal.hide('RemoveModal')">
            {{ dataLang['clients_register_text_142'] }}
          </div>
          <div @click="acceptRemove"
            class="btn btn-sm btn-primary action-hover px-20 rounded-5 d-flex align-items-center justify-content-center text-uppercase"
            :class="{'disabled':acceptRemoveLoading}">
            {{ dataLang['clients_register_text_143'] }}
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import ObjectsService from "@/api/ObjectsService";
import EventBus from "@/event-bus.js";
import GeneralService from "@/api/GeneralService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import AddBalanceModal from "./AddBalanceModal.vue";
import WriteOffClientsModal from "./WriteOffClientsModal.vue";
import BackBalanceClientsModal from "./BackBalanceClientsModal.vue";
export default {
  components: {
    VeTable,
    AddBalanceModal,
    WriteOffClientsModal,
    BackBalanceClientsModal,
  },

  props: {
    modalInfo: {
      type: Object,
    },

    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      acceptRemoveLoading: false,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      tabInfo: this.modalInfo,
      computedAllPage: 1,
      pincode: "",
      activePagePagination: {},
      limitPaginationValue: 100,
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },

      selectsData: {
        type: [],
      },
      selectsFilter: {
        type: [],
      },
      dataForTab: {},
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "finreestr__amount") {
            return row?.finreestr__amount < 0 ? "text-danger" : "text-success";
          }
        },
      },
    };
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    async loadExel() {
      let dataFrom = await GeneralService.toSpecExcel(
        `/super/companies/tab/balance/${this.tabInfo.id}/xlsx?pincode=${this.pincode}`
      );

      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple) {
        EventBus.$emit("openModal", {
          data: null,
          nameForAction: "acceptDeleteNote",
          mode: "create",
        });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    setRemoveModal(){
      if (this.activeSelectRowsMultiple?.length) {
        console.log(this.activeSelectRowsMultiple)
        this.$modal.show('RemoveModal')
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    acceptRemove() {
      if (this.activeSelectRowsMultiple?.length) {
        this.acceptRemoveLoading = true
        GeneralService.delete("/super/companies/balance-history/" + this.activeSelectRowsMultiple)
          .then((data) => {
            this.loadData(1);
            this.$toast.success(data.data.message);
            this.$modal.hide("RemoveModal");
            this.acceptRemoveLoading = false

            EventBus.$emit('contentLoaded')
            EventBus.$emit('updateContentData')
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
            this.$modal.hide("RemoveModal");
            this.acceptRemoveLoading = false
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    closeDeleteModal() {
      EventBus.$emit("closeModal", {
        data: null,
        nameForAction: "acceptDeleteNote",
        mode: "create",
      });
      this.activeSelectRowsMultiple = [];
    },

    deleteRow() {
      this.$emit("loadingModal", true);
      ObjectsService.delete(
        "notes",
        this.currentOpenedId,
        this.activeSelectRowsMultiple
      )
        .then((data) => {
          this.loadData();
          this.activeSelectRowsMultiple = [];
          this.closeDeleteModal();
        })
        .catch((err) => {
          this.$emit("loadingModal", false);

          this.activeSelectRowsMultiple = [];
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
    openModalSingle(nameModal) {
      EventBus.$emit("openModal", {
        data: null,
        nameForAction: nameModal,
        mode: "create",
      });
    },
    loadData(newNumPage) {
      this.localLoading = true;
      GeneralService.get(`/super/companies/tab/balance/${this.tabInfo.id}`, {
        params: {
          ...this.paginationBalanceStateParams,
          where: JSON.stringify([...this.filter, ...this.typeFilter]),
        },
      })
        .then((data) => {
          this.dataTable = data.data.data.rows;
          this.activeSelectRowsMultiple = null;
          this.localLoading = false;
          this.getBalanceAll(data.data.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    resetFilter() {
      this.filter = [];
      this.loadData();
      this.$refs.serviceTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
    },
    fillFilter(data) {
      console.log(data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        let indexed = this.filter.findIndex((x) => x.field == data.name);
        this.filter[indexed].value = newValueFilter;
        if (data?.operator) {
          this.filter[indexed].operator = data.operator;
        }
      }
      let indexed = this.filter.findIndex((x) => x.field == data.name);
      if (indexed !== -1) {
        this.filter[indexed].value = newValueFilter;
        if (data.type == "delete") {
          this.filter.splice(indexed, 1);
        }
      }
    },
    // fillTypeFilter(data) {},
    // this.fillTypeFilter({
    //                   name: 'finreestr__type',
    //                   value: e.value,
    //                   ...(e?.type && { type: e?.type })
    //                 })
    loadGlobal() {
      GeneralService.get(`/super/companies/tab/info/${this.tabInfo.id}`)
        .then((data) => {
          console.log(data);
          this.dataForTab = data.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    ...mapActions("balancePagiation", ["getBalanceAll"]),
  },
  mounted() {
    GeneralService.get(
      `/settings?fields=company_settings__set_security_pass_for_forbidden`
    )
      .then((data) => {
        this.pincode =
          data.data.data.rows[0].company_settings__set_security_pass_for_forbidden;
      })
      .catch((e) => { });
    this.loadData();
    dayjs.extend(utc);
    EventBus.$on("updateContentData", () => {
      this.loadGlobal();
      this.loadData();
    });
  },
  created() {
    this.selectsData.type = [
      {
        label: "Любой",
        value: "",
        type: "delete",
      },
      {
        label: "Расход",
        value: "finreestr_rowtype_spend",
      },
      {
        label: "Доход",
        value: "finreestr_rowtype_coming",
      },
    ];
    this.selectsFilter.type = this.selectsData.type[0];
    this.loadGlobal();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("balancePagiation", ["paginationBalanceStateParams"]),
    ...mapGetters("balancePagiation", ["numPages"]),
    typeFilter() {
      let type = this.selectsFilter.type;

      switch (type.value) {
        case "":
          return []
          break;
        case "finreestr_rowtype_spend":
          return [{
            OR: [
              { field: "finreestr__type", value: "finreestr_rowtype_spend" },
              { field: "finreestr__type", value: "finreestr_rowtype_transit" },
            ],
          }];
          break;

        case "finreestr_rowtype_coming":
          return [{
            field: "finreestr__type",
            value: 'finreestr_rowtype_coming'
          }];
          break;
      }
    },
    checkboxOption() {
      return {
        hideSelectAll: false,
        selectedRowChange: this.selectedRowChange,
        selectedAllChange: this.selectedAllChange,
        selectedRowKeys: [],
      };
    },
    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "finreestr__created_at",
          key: "1",
          title: this.dataLang["reg_company_94"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like", mod: "datetimeUTC" }}
                  inputName={"finreestr__created_at"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.finreestr__created_at
                  ? dayjs(row.finreestr__created_at)
                    .utc(true)
                    .utcOffset(Number(this.userSetting.company__utc))
                    .format(
                      `${this.userSetting.company__tempalte_date} HH:mm`
                    )
                  : ""}
              </span>
            );
          },
        },

        {
          field: "finreestr__amount",
          key: "25",
          title: this.dataLang["reg_company_95"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__amount"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                class={
                  row.finreestr__type == "finreestr_rowtype_spend"
                    ? ``
                    : `text-confirmation`
                }
              >
                {row.finreestr__type == "finreestr_rowtype_spend"
                  ? `-${row.finreestr__amount.split(".").join(",")}`
                  : `+${row.finreestr__amount.split(".").join(",")}`}
              </span>
            );
          },
        },
        {
          field: "finreestr__type",
          key: "314",
          title: this.dataLang["reg_company_96"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.type}
                  style={"width: 100%"}
                  label={"label"}
                  placeholder={""}
                  id={"id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.type}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.dataLang[row.finreestr__type]}</span>;
          },
        },
        {
          field: "finreestr__basis",
          key: "331",
          title: this.dataLang["reg_company_97"],
          align: "left",
          width: "40%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__basis"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "finreestr__manager",
          key: "324",
          title: this.dataLang["reg_company_98"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"finreestr__manager"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "finreestr__id",
          key: "23",
          title: this.dataLang["reg_company_99"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  inputName={"finreestr__id"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
